export const isValidEmail = (str) => {
	if (str.includes('@')) return str.split('@')[1].includes('.')
	return false
}
